export default __webpack_public_path__ + "static/media/signup.e9b9495e.svg";